import { createOpenStore } from "stores/createOpenStore";

export interface CheckpointsOpen {
  tableId: string;
  /** The table's directory item: the history reads the table by it. */
  itemId: string;
  /** What opened it; the history sits over the action bar either way. */
  anchor?: HTMLElement;
}

export const useCheckpointsStore = createOpenStore<CheckpointsOpen>();
